import React, { useContext, useEffect, useState } from "react"
import { Box, IconButton, InputAdornment, Popover, TextField, CircularProgress, Typography, useTheme } from "@mui/material"
import CommonTypo from "./CommonTypo";
import SendIcon from '@mui/icons-material/Send';
import { v4 } from "uuid"
import { userService } from "../services/auth";
import { UserTypeContext } from "../context/userStatus";
import useWidth from "../utils/useWidth";
import { baseEndpoints } from "../services/config";
import NewButton from "./NewButton";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { ArrowUpNew } from "../assets/images/icon/ArrowDownGreenNew";
import insightsProgressStyles from "../view/insightsV2/insightsClasses";

dayjs.extend(customParseFormat);

const inputEnabledActions = ["description", "follow_up", "holiday_dates_form"];

const convertToActualResultsJson = (text: string) => {

    // Step 1: Split the answer and follow-up part
    const followUpIndex = text.indexOf("Follow-Up Suggestions:");
    let answer = '';
    let follow_up_questions = [];

    if (followUpIndex !== -1) {
        // Follow-up section exists
        answer = text.slice(0, followUpIndex).replace(/^Answer:\s*/i, '').trim();

        const followUpText = text.slice(followUpIndex);
        follow_up_questions = [...followUpText.matchAll(/\[(.*?)\]/g)].map(m => m[1].trim());
    } else {
        // Only answer section exists
        answer = text.replace(/^Answer:\s*/i, '').trim();
    }

    return {
        answer,
        follow_up_questions
    };
}
const Chatbot = () => {
    const [isPopupOpen, setIsPopupOpen] = React.useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [myChatId, setMyChatId] = React.useState(v4());
    const [inputValue, setInputValue] = React.useState(null);
    const [questionAnswers, setQuestionAnswers] = React.useState([]);
    const [followUpQuestions, setfollowUpQuestions] = React.useState([])
    const [scrolledToBottom, setScrolledToBottom] = React.useState(false);
    const [suggestionList, setSuggestionList] = React.useState([]);
    const [selectedSuggestion, setSelectedSuggestion] = React.useState(null);

    // Dynamic flow state management
    const [currentFlowData, setCurrentFlowData] = React.useState(null);
    const [quickReplies, setQuickReplies] = React.useState([]);
    const [dataOptions, setDataOptions] = React.useState({});
    const [selectedDataOptions, setSelectedDataOptions] = React.useState([]);
    const [chatHistory, setChatHistory] = React.useState([]);
    const [nextAction, setNextAction] = React.useState(null);
    const [isInFlow, setIsInFlow] = React.useState(false);
    const [isTextInputEnabled, setIsTextInputEnabled] = React.useState(true);

    // Attachment state management
    const [selectedFiles, setSelectedFiles] = React.useState([]);
    const [uploadedPaths, setUploadedPaths] = React.useState([]);
    const [isUploading, setIsUploading] = React.useState(false);
    const [messageAttachments, setMessageAttachments] = React.useState([]);

    // Notification state management
    const [notificationData, setNotificationData] = React.useState(null);
    const [notificationAnchorEl, setNotificationAnchorEl] = React.useState(null);
    const [isNotificationOpen, setIsNotificationOpen] = React.useState(false);
    const [isFromNotification, setIsFromNotification] = React.useState(false);

    // Date picker state for holiday mode
    const [holidayStartDate, setHolidayStartDate] = React.useState(null);
    const [holidayEndDate, setHolidayEndDate] = React.useState(null);
    const [startDatePickerOpen, setStartDatePickerOpen] = React.useState(false);
    const [endDatePickerOpen, setEndDatePickerOpen] = React.useState(false);
    const [startDateAnchorEl, setStartDateAnchorEl] = React.useState(null);
    const [endDateAnchorEl, setEndDateAnchorEl] = React.useState(null);

    const scrollContainerRef = React.useRef(null);
    const notificationFetchedRef = React.useRef(false);
    const { state: outcomeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const { userDetails = {} } = outcomeState
    console.log("outcomeState", outcomeState);
    const isDarkMode = useTheme().palette.mode === "dark" || outcomeState.isDarkMode
    const handleClick = (event) => {
        setIsPopupOpen(!isPopupOpen)
        setAnchorEl(event.currentTarget);
        // Reset flow state when opening
        if (!isPopupOpen) {
            resetFlowState();
        }
    };

    const handleClose = () => {
        setIsPopupOpen(!isPopupOpen)
        setAnchorEl(null);
        // Reset flow state when closing
        resetFlowState();
    };

    const processDataOptions = (data) => {
        if (!data || typeof data !== 'object') return {};

        const sections = {};
        console.log("[processDataOptions] Object.keys(data)", Object.keys(data), data);
        console.log("[processDataOptions] notificationData", notificationData);


        if (Object.keys(data).length === 0) return {};
        Object.keys(data).forEach(key => {
            // Skip attachments as they are not selectable options
            if (key === 'attachments') return;
            if (notificationData?.notification?.type === 'NOT_TRACKING_SPECIFIC_DAY' && Array.isArray(data[key])) {
                console.log("[processDataOptions] data[key]", data[key]);
                sections[key] = data[key].map(item => ({
                    text: item,
                    value: item,
                    type: key,
                    id: item
                }));
            } else if (Array.isArray(data[key])) {
                sections[key] = data[key].map(item => ({
                    text: item.name || item.question,
                    value: item.outcomeId || item.influenceId || item.reflectiveId || item._id,
                    type: key,
                    id: item._id,
                    selected: false
                }));
            }

        });
        console.log("[processDataOptions] sections", sections);
        return sections;
    };

    const resetFlowState = () => {
        setCurrentFlowData(null);
        setQuickReplies([]);
        setDataOptions({});
        setSelectedDataOptions([]);
        setChatHistory([]);
        setNextAction(null);
        setIsInFlow(false);
        setIsTextInputEnabled(true);
        setSelectedSuggestion(null);
        setfollowUpQuestions([]);
        setSelectedFiles([]);
        setUploadedPaths([]);
        setIsUploading(false);
        setIsFromNotification(false);
    };

    const fetchFreshData = () => {
        // Dispatch custom event to refresh tracking data
        const refreshEvent = new CustomEvent('refreshTrackingData', {
            detail: { source: 'chatbot', action: 'ARCHIVE_METRICS' }
        });
        window.dispatchEvent(refreshEvent);
    }

    const fetchNotificationPriority = async () => {
        try {
            const token = localStorage.getItem("userDetails");
            const response = await userService.getNotificationPriority(token);

            if (response.status && response.data?.notification) {
                setNotificationData(response.data);
                // Auto-show notification after a short delay
                setTimeout(() => {
                    // Set the chatbot Box element as anchor for the popover
                    const chatbotElement = document.querySelector('[data-chatbot-trigger]');
                    if (chatbotElement) {
                        setNotificationAnchorEl(chatbotElement);
                    }
                    setIsNotificationOpen(true);
                }, 1000);
            }
        } catch (error) {
            console.error('Error fetching notification priority:', error);
        }
    }

    const handleNotificationClick = (event) => {
        if (notificationData) {
            setNotificationAnchorEl(event?.currentTarget || null);
            setIsNotificationOpen(true);
        }
    }

    const handleNotificationClose = () => {
        setIsNotificationOpen(false);
        setNotificationAnchorEl(null);
    }

    // Fetch notification on component mount (only once per refresh)
    useEffect(() => {
        if (!notificationFetchedRef.current) {
            notificationFetchedRef.current = true;
            fetchNotificationPriority();
        }
    }, []);

    const handleFileSelection = (event) => {
        const files = Array.from(event.target.files);
        setSelectedFiles(prev => [...prev, ...files]);
    };

    const removeFile = (index) => {
        setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const uploadFiles = async () => {
        if (selectedFiles.length === 0) return [];

        setIsUploading(true);
        try {
            const token = localStorage.getItem("userDetails");
            const response = await userService.uploadAttachments(selectedFiles, token);

            if (response.status) {
                setUploadedPaths(response.paths);
                return response.paths;
            } else {
                console.error("Upload failed:", response);
                return [];
            }
        } catch (error) {
            console.error("Upload error:", error);
            return [];
        } finally {
            setIsUploading(false);
        }
    };

    const open = Boolean(anchorEl) && isPopupOpen;

    // Auto-scroll to bottom when new messages are added or suggestions change
    React.useEffect(() => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
        }
    }, [questionAnswers, suggestionList]);

    React.useEffect(() => {
        getSuggestionList()
    }, [])

    const getSuggestionList = () => {
        const token = localStorage.getItem("userDetails")
        userService.chatBotSuggestionList(token).then((data) => {
            console.log("data", data)
            setSuggestionList(data?.data)
            // Auto-scroll to bottom after suggestions are loaded
            setTimeout(() => {
                if (scrollContainerRef.current) {
                    scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
                }
            }, 100);
        }).catch((error) => {
            console.log("suggestion list error", error)
        })
    }

    // Auto-scroll to bottom when popup opens
    React.useEffect(() => {
        if (isPopupOpen) {

            // Add a small delay to ensure DOM is ready
            setTimeout(() => {
                setScrolledToBottom(false)
                if (scrollContainerRef.current) {
                    scrollContainerRef.current.scrollTop = scrollContainerRef.current.scrollHeight;
                    setScrolledToBottom(true)
                }
            }, 100);
        }
    }, [isPopupOpen, scrolledToBottom]);

    // Extract metric names from response message (strings in single quotes)
    const extractMissingMetricsFromMessage = (message) => {
        if (!message) return [];

        // Pattern 1: Extract metric after "tracked" and before "(+N more)"
        // Example: "You're on the metrics, but haven't tracked 'Relationship Satisfaction' (+6 more) in 5 days"
        const trackedPattern = /tracked\s+'([^']+)'\s+\(\+\d+\s+more\)/;
        const trackedMatch = message.match(trackedPattern);

        if (trackedMatch) {
            const metric = trackedMatch[1].trim();
            console.log("Extracted missingMetrics from tracked pattern:", [metric]);
            return [metric];
        }

        // Pattern 2: Extract single metric after "tracked" (no "+N more")
        // Example: "You're on the metrics, but haven't tracked 'wellbeing' in 5 days"
        const singleTrackedPattern = /tracked\s+'([^']+)'\s+in\s+\d+\s+days/;
        const singleTrackedMatch = message.match(singleTrackedPattern);

        if (singleTrackedMatch) {
            const metric = singleTrackedMatch[1].trim();
            console.log("Extracted missingMetrics from single tracked pattern:", [metric]);
            return [metric];
        }

        // Fallback: Find all strings covered in single quotes
        const singleQuoteMatches = message.match(/'([^']+)'/g);
        if (!singleQuoteMatches) return [];

        // Extract the content inside quotes and clean it up
        const metrics = singleQuoteMatches.map(match => {
            // Remove the single quotes and trim whitespace
            return match.replace(/'/g, '').trim();
        });

        console.log("Extracted missingMetrics from fallback pattern:", metrics);
        return metrics;
    };

    // Extract day name from response message
    const extractDayNameFromMessage = (message) => {
        // example message string: You skip tracking every Saturday - want to exclude it from streak logic?
        // example message string: You skip tracking every Sunday / Monday / Tuesday / Wednesday / Thursday / Friday — want to exclude it from streak logic?
        if (!message) return undefined;

        // Pattern 1: Extract day name after "skip tracking every" and before "-" or "—"
        // Match both single dash "-" and em dash "—"
        const dayNamePattern = /skip\s+tracking\s+every\s+([^/\-—]+?)\s*[-—]\s+want\s+to\s+exclude\s+it\s+from\s+streak\s+logic\?/i;
        const dayNameMatch = message.match(dayNamePattern);

        if (dayNameMatch) {
            const dayName = dayNameMatch[1].trim();
            
            // Check if it contains " / " which indicates multiple days
            if (dayName.includes(' / ')) {
                console.log("Multiple days detected, returning undefined:", dayName);
                return undefined; // Return undefined for multiple days
            }
            
            console.log("Extracted day name from message:", dayName);
            return dayName; // Return single day name (not as array)
        }

        // Fallback: Find all strings covered in single quotes
        const dayNameMatches = message.match(/'([^']+)'/);
        if (!dayNameMatches) return undefined;

        // Extract the content inside quotes and clean it up
        const dayName = dayNameMatches[1].trim();
        
        // Check if it contains " / " which indicates multiple days
        if (dayName.includes(' / ')) {
            console.log("Multiple days detected in fallback, returning undefined:", dayName);
            return undefined; // Return undefined for multiple days
        }

        console.log("Extracted day name from fallback pattern:", dayName);
        return dayName; // Return single day name (not as array)
    };

    const handleDynamicFlow = async (questionType, userAnswer = null, skipLoading = false, providedChatId = null) => {
        const token = localStorage.getItem("userDetails")
        const chatId = providedChatId || v4()
        console.log("notificationData", notificationData)
        const requestBody = {
            question_type: questionType,
            ...(userAnswer && { user_answer: userAnswer }),
            ...(chatHistory.length > 0 && { chat_history: chatHistory }),
            ...(questionType === "NOT_TRACKING_SPECIFIC_METRIC" && { missingMetrics: extractMissingMetricsFromMessage(notificationData?.notification?.message) }),
            ...(questionType === "NOT_TRACKING_SPECIFIC_DAY" && (() => {
                const dayName = extractDayNameFromMessage(notificationData?.notification?.message);
                return dayName ? { dayName } : {};
            })())
        }

        // Extract missingMetrics from response message for NOT_TRACKING_SPECIFIC_METRIC flow
        if (questionType === "NOT_TRACKING_SPECIFIC_METRIC") {
            const missingMetrics = extractMissingMetricsFromMessage(notificationData?.notification?.message);
            if (missingMetrics.length > 0) {
                requestBody.missingMetrics = missingMetrics;
            }
        }

         // Extract dayName from response message for NOT_TRACKING_SPECIFIC_DAY flow
         if (questionType === "NOT_TRACKING_SPECIFIC_DAY") {
            const dayName = extractDayNameFromMessage(notificationData?.notification?.message);
            if (dayName) {
                requestBody.dayName = dayName;
            }
        }

        try {
            if (!skipLoading && userAnswer) {
                setLoading(true, chatId, userAnswer)
            }

            const response = await userService.handleChatbotFlow(requestBody, token)
            console.log("Flow response:", response)

            if (response.status && response.data) {
                const flowData = response.data

                // Process data object to create options
                const processedDataOptions = processDataOptions(flowData.data)
                const hasDataOptions = Object.keys(processedDataOptions).length > 0

                // Update flow state
                setCurrentFlowData(flowData)
                setNextAction(flowData.next_action)
                setQuickReplies(flowData.quickReplies || [])
                setDataOptions(processedDataOptions)
                setSelectedDataOptions([])
                setChatHistory(flowData.chatHistory || [])
                setIsInFlow(true)

                // Handle text input based on next_action and available options
                console.log("Flow next_action:", flowData.next_action, "isTextInputEnabled will be:", inputEnabledActions.includes(flowData.next_action));
                if (inputEnabledActions.includes(flowData.next_action)) {
                    setIsTextInputEnabled(true)
                } else if (flowData.next_action === "completion") {
                    // Completion means flow is complete
                    setIsTextInputEnabled(true)
                    setIsInFlow(false)
                    if (questionType === "ARCHIVE_METRICS") {
                        fetchFreshData()
                    }
                    if (questionType === "NOT_TRACKING_SPECIFIC_METRIC") {
                        fetchFreshData()
                    }
                    setDataOptions({})
                    setSelectedSuggestion(null) // Clear selected suggestion
                    getSuggestionList() // Fetch suggestions when flow completes
                } else if (flowData.next_action) {
                    setIsTextInputEnabled(false)
                } else {
                    // No next_action means flow is complete
                    setIsTextInputEnabled(true)
                    setIsInFlow(false)
                    setSelectedSuggestion(null) // Clear selected suggestion
                    if (questionType === "ARCHIVE_METRICS") {
                        fetchFreshData()
                    }
                    if (questionType === "NOT_TRACKING_SPECIFIC_DAY") {
                        fetchFreshData()
                    }
                    getSuggestionList() // Fetch suggestions when flow completes
                }

                // Add bot message to chat
                if (skipLoading) {
                    // Update the existing loading message
                    setQuestionAnswers(prevAnswers => {
                        const currentAnswers = [...prevAnswers]
                        const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                        if (loadingIndex > -1) {
                            currentAnswers[loadingIndex].loading = false
                            currentAnswers[loadingIndex].text = flowData.message
                        }
                        return currentAnswers
                    })
                } else {
                    // For initial requests without loading, add bot message directly
                    if (!userAnswer) {
                        setQuestionAnswers(prevAnswers => {
                            const currentAnswers = [...prevAnswers]
                            currentAnswers.push({
                                text: flowData.message,
                                sendBy: "chat",
                                loading: false,
                                id: chatId
                            })
                            return currentAnswers
                        })
                    } else {
                        setLoading(false, chatId, flowData.message)
                    }
                }

                // Clear suggestion list when entering flow
                if (!userAnswer) {
                    setSuggestionList([])
                }
            } else {
                if (skipLoading) {
                    setQuestionAnswers(prevAnswers => {
                        const currentAnswers = [...prevAnswers]
                        const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                        if (loadingIndex > -1) {
                            currentAnswers[loadingIndex].loading = false
                            currentAnswers[loadingIndex].text = "Sorry, I couldn't process that request."
                        }
                        return currentAnswers
                    })
                } else {
                    setLoading(false, chatId, "Sorry, I couldn't process that request.")
                }
            }
        } catch (error) {
            console.error("Flow error:", error)
            if (skipLoading) {
                setQuestionAnswers(prevAnswers => {
                    const currentAnswers = [...prevAnswers]
                    const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                    if (loadingIndex > -1) {
                        currentAnswers[loadingIndex].loading = false
                        currentAnswers[loadingIndex].text = "Sorry, something went wrong."
                    }
                    return currentAnswers
                })
            } else {
                setLoading(false, chatId, "Sorry, something went wrong.")
            }
        }
    }

    const handleDynamicFlowWithAttachments = async (requestBody, skipLoading = false, providedChatId = null) => {
        const token = localStorage.getItem("userDetails")
        const chatId = providedChatId || v4()

        try {
            const response = await userService.handleChatbotFlow(requestBody, token)
            console.log("Flow response with attachments:", response)

            if (response.status && response.data) {
                const flowData = response.data

                // Process data object to create options
                const processedDataOptions = processDataOptions(flowData.data)
                const hasDataOptions = Object.keys(processedDataOptions).length > 0

                // Update flow state
                setCurrentFlowData(flowData)
                setNextAction(flowData.next_action)
                setQuickReplies(flowData.quickReplies || [])
                setDataOptions(processedDataOptions)
                setSelectedDataOptions([])
                setChatHistory(flowData.chatHistory || [])
                setIsInFlow(true)

                // Handle text input based on next_action and available options
                console.log("Flow next_action:", flowData.next_action, "isTextInputEnabled will be:", inputEnabledActions.includes(flowData.next_action));
                if (inputEnabledActions.includes(flowData.next_action)) {
                    setIsTextInputEnabled(true)
                } else if (flowData.next_action === "completion") {
                    // Completion means flow is complete
                    setIsTextInputEnabled(true)
                    setIsInFlow(false)
                    setSelectedSuggestion(null) // Clear selected suggestion
                    getSuggestionList() // Fetch suggestions when flow completes
                } else if (flowData.next_action) {
                    setIsTextInputEnabled(false)
                } else {
                    // No next_action means flow is complete
                    setIsTextInputEnabled(true)
                    setIsInFlow(false)
                    setSelectedSuggestion(null) // Clear selected suggestion
                    getSuggestionList() // Fetch suggestions when flow completes
                }

                // Add bot message to chat
                if (skipLoading) {
                    // Update the existing loading message
                    setQuestionAnswers(prevAnswers => {
                        const currentAnswers = [...prevAnswers]
                        const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                        if (loadingIndex > -1) {
                            currentAnswers[loadingIndex].loading = false
                            currentAnswers[loadingIndex].text = flowData.message
                            // Add attachments if present in response
                            if (flowData.data?.attachments) {
                                currentAnswers[loadingIndex].attachments = flowData.data.attachments
                            }
                        }
                        return currentAnswers
                    })
                } else {
                    setLoading(false, chatId, flowData.message)
                }

                // Clear suggestion list when entering flow
                if (!requestBody.user_answer) {
                    setSuggestionList([])
                }

                // Clear attachments after successful submission
                setSelectedFiles([])
                setUploadedPaths([])
            } else {
                if (skipLoading) {
                    setQuestionAnswers(prevAnswers => {
                        const currentAnswers = [...prevAnswers]
                        const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                        if (loadingIndex > -1) {
                            currentAnswers[loadingIndex].loading = false
                            currentAnswers[loadingIndex].text = "Sorry, I couldn't process that request."
                        }
                        return currentAnswers
                    })
                } else {
                    setLoading(false, chatId, "Sorry, I couldn't process that request.")
                }
            }
        } catch (error) {
            console.error("Flow error:", error)
            if (skipLoading) {
                setQuestionAnswers(prevAnswers => {
                    const currentAnswers = [...prevAnswers]
                    const loadingIndex = currentAnswers.findIndex(item => item.id === chatId + "_loading")
                    if (loadingIndex > -1) {
                        currentAnswers[loadingIndex].loading = false
                        currentAnswers[loadingIndex].text = "Sorry, something went wrong."
                    }
                    return currentAnswers
                })
            } else {
                setLoading(false, chatId, "Sorry, something went wrong.")
            }
        }
    }

    const askQuesrtion = async (textValue) => {
        if (isInFlow && inputEnabledActions.includes(nextAction)) {
            // Handle text input in suggestion flow - continue with handleDynamicFlow
            const chatId = v4()

            // Upload files first if any are selected
            const attachmentPaths = await uploadFiles();

            // Add user selection to chat and set loading
            setQuestionAnswers(prevAnswers => {
                const currentAnswers = [...prevAnswers]
                // Add user selection
                currentAnswers.push({
                    text: textValue,
                    sendBy: "self",
                    id: chatId
                })
                // Add loading bot response
                currentAnswers.push({
                    sendBy: "chat",
                    loading: true,
                    id: chatId + "_loading",
                    text: textValue
                })
                return currentAnswers
            })

            // Continue suggestion flow with text input and attachments
            const requestBody = {
                question_type: selectedSuggestion?.question_type || notificationData?.type,
                user_answer: textValue,
                ...(attachmentPaths.length > 0 && { attachments: attachmentPaths }),
                ...(chatHistory.length > 0 && { chat_history: chatHistory })
            };
            if (nextAction === "holiday_dates_form") {
                if (holidayStartDate && holidayEndDate) {
                    (requestBody as any).startDate = holidayStartDate;
                    (requestBody as any).endDate = holidayEndDate;
                    (requestBody as any).holidayMode = "ON";
                }
            }
            handleDynamicFlowWithAttachments(requestBody, true, chatId)
        } else if (!selectedSuggestion) {
            const chatId = v4()
            setLoading(true, chatId, textValue)
            const token = localStorage.getItem("userDetails")
            userService.askChatBotQuestionV2({
                "question": textValue,
                "chatId": myChatId
            }, token).then((data) => {
                console.log("data", data);

                let finalAnswer = convertToActualResultsJson(data.text)
                setfollowUpQuestions(finalAnswer.follow_up_questions)
                setLoading(false, chatId, finalAnswer.answer)
            }).catch(() => {
                setLoading(false, chatId)
            })
        } else {
            // Start dynamic flow with selected suggestion
            handleDynamicFlow(selectedSuggestion?.question_type || notificationData?.type)
        }
    }

    const handleQuickReplySelection = (quickReply) => {
        const chatId = v4()

        // Clear quick replies immediately after selection
        setQuickReplies([])

        // Add user selection to chat and set loading
        setQuestionAnswers(prevAnswers => {
            const currentAnswers = [...prevAnswers]
            // Add user selection
            currentAnswers.push({
                text: quickReply.text,
                sendBy: "self",
                id: chatId
            })
            // Add loading bot response with the selected text
            currentAnswers.push({
                sendBy: "chat",
                loading: true,
                id: chatId + "_loading",
                text: quickReply.text
            })
            return currentAnswers
        })

        // Continue flow with selected answer
        const questionType = selectedSuggestion?.question_type || notificationData?.type
        handleDynamicFlow(questionType, quickReply.value, true, chatId)
    }

    const handleDataOptionToggle = (sectionKey, optionId) => {
        console.log("[handleDataOptionToggle]notificationData", notificationData);

        const isSingleSelect = notificationData?.type === 'NOT_TRACKING_SPECIFIC_DAY';

        // First, get the current state before updating
        setDataOptions(prevData => {
            const newData = { ...prevData };
            if (newData[sectionKey]) {
                const clickedOption = newData[sectionKey].find(opt => opt.id === optionId);
                if (!clickedOption) return newData;

                const wasSelected = clickedOption.selected || false;

                if (isSingleSelect) {
                    // Single select: deselect all, then select the clicked one if it wasn't selected
                    newData[sectionKey] = newData[sectionKey].map(option => ({
                        ...option,
                        selected: option.id === optionId ? !wasSelected : false
                    }));

                    // Update selectedDataOptions for single select
                    setSelectedDataOptions(() => {
                        if (wasSelected) {
                            // Deselect the current option
                            return [];
                        } else {
                            // Select only this option (use original clickedOption before update)
                            return [{ ...clickedOption, selected: true }];
                        }
                    });
                } else {
                    // Multi select: toggle only the clicked one
                    newData[sectionKey] = newData[sectionKey].map(option =>
                        option.id === optionId
                            ? { ...option, selected: !option.selected }
                            : option
                    );

                    // Update selectedDataOptions for multi select
                    setSelectedDataOptions(prevSelected => {
                        if (wasSelected) {
                            // Remove from selected
                            return prevSelected.filter(opt => opt.id !== optionId);
                        } else {
                            // Add to selected
                            return [...prevSelected, { ...clickedOption, selected: true }];
                        }
                    });
                }
            }
            return newData;
        });
    };

    const handleDataOptionsSubmit = () => {
        if (selectedDataOptions.length === 0) return;

        const chatId = v4()
        const selectedTexts = selectedDataOptions.map(opt => opt.text).join(', ');

        // Clear data options immediately after submission
        setDataOptions({})
        setSelectedDataOptions([])

        // Add user selection to chat and set loading
        setQuestionAnswers(prevAnswers => {
            const currentAnswers = [...prevAnswers]
            // Add user selection
            currentAnswers.push({
                text: selectedTexts,
                sendBy: "self",
                id: chatId
            })
            // Add loading bot response with the selected text
            currentAnswers.push({
                sendBy: "chat",
                loading: true,
                id: chatId + "_loading",
                text: selectedTexts
            })
            return currentAnswers
        })
        const isSingleSelect = notificationData?.type === 'NOT_TRACKING_SPECIFIC_DAY';
        console.log("[handleDataOptionsSubmit]notificationData", isSingleSelect, notificationData);

        // Continue flow with selected data options as array
        const selectedValues = selectedDataOptions.map(opt => opt.value);
        handleDynamicFlow(selectedSuggestion?.question_type || notificationData?.type, isSingleSelect ? selectedValues[0] : selectedValues, true, chatId)
    }

    const onHandleInputSubmit = () => {
        if (inputValue) {
            askQuesrtion(inputValue)
            setInputValue("")
        }
    }
    const setLoading = (loading, id, message = null) => {
        setQuestionAnswers(prevAnswers => {
            const currentquestionAnswers = [...prevAnswers]
            if (!loading) {
                const found = currentquestionAnswers.findIndex(item => item.id === id)
                if (found > -1) {
                    currentquestionAnswers[found].loading = false
                    currentquestionAnswers[found].text = message
                }
            } else {
                currentquestionAnswers.push({
                    text: message,
                    sendBy: "self",
                    id: v4()
                })
                currentquestionAnswers.push({
                    sendBy: "chat",
                    loading,
                    id,
                    text: ""
                })
            }
            return currentquestionAnswers
        })
    }
    console.log("Chatbot State:", {
        suggestionList,
        questionAnswers,
        followUpQuestions,
        quickReplies,
        dataOptions,
        selectedDataOptions,
        isInFlow,
        nextAction,
        isTextInputEnabled,
        chatHistory
    });
    const getNotificationPopoverButtonText = () => {
        console.log("[getNotificationPopoverButtonText] notificationData", notificationData);
        if (notificationData.type === 'RATING') {
            return 'Rate Now';
        } else if (notificationData.type === 'NO_RESPONSE_4_DAYS') {
            return 'Yes';
        } else if (notificationData.type === 'NOT_TRACKING_SPECIFIC_METRIC') {
            return 'No';
        } else if (notificationData.type === 'NOT_TRACKING_SPECIFIC_DAY') {
            return 'Yes';
        } else if (notificationData.type === 'APP_RATING') {
            return 'Yes';
        } else {
            return 'No, I\'m good';
        }
    }
    const getNotificationPopoverCancelButtonText = () => {
        if (notificationData.type === 'RATING') {
            return 'No, I\'m good';
        } else if (notificationData.type === 'NO_RESPONSE_4_DAYS') {
            return 'No';
        } else if (notificationData.type === 'NOT_TRACKING_SPECIFIC_METRIC') {
            return 'Yes';
        } else if (notificationData.type === 'NOT_TRACKING_SPECIFIC_DAY') {
            return 'No';
        } else if (notificationData.type === 'APP_RATING') {
            return 'No';
        } else {
            return 'No, I\'m good';
        }
    }
    const width = useWidth();
    const isMobile = width < 768;
    const classes = insightsProgressStyles();
    return <Box position={"fixed"} zIndex={1} height={"63px"} width={"63px"} bottom={"20px"} right={"20px"} borderRadius={"100%"} sx={{
        background: outcomeState.isDarkMode ? "transparent" : "white"
    }}>
        <LocalizationProvider dateAdapter={AdapterDayjs} >
            {!isMobile && (
                <Box
                    data-chatbot-trigger
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer"
                    }}
                    onClick={handleClick}
                >
                    <img src={"/chatbot.svg"} style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "12px 12px 0px 0px",
                        objectPosition: "center 75%"
                    }} alt="login"></img>
                </Box>
            )}
            {isPopupOpen && <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'center',
                    horizontal: 'center',
                }}
                PaperProps={{
                    sx: {
                        borderRadius: "12px",
                        boxShadow: "0px 0px 12px 0px #0000001A",
                        width: "375px",
                        height: "calc(100vh - 30%)",
                        padding: "24px 16px",
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "column"
                    }

                }}

            >
                <Box display={"flex"} width={"100%"} flexDirection={"column"} alignItems={"center"} height={"100%"} gap={"24px"} position={"relative"}>
                    <Box display={"flex"} width={"100%"} alignItems={"center"} gap={"16px"} justifyContent={"space-between"}>
                        <Box display={"flex"} width={"100%"} alignItems={"center"} gap={"16px"}>
                            <Box height={"48px"} width={"48px"} sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer"
                            }} onClick={handleClick}>
                                <img src={"/chatbotinner.svg"} style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "12px 12px 0px 0px",
                                    objectPosition: "center 75%"
                                }} alt="login"></img>
                            </Box>
                            <Box display={"flex"} alignContent={"flex-start"} flexDirection={"column"}>
                                <CommonTypo size={16} fontWeight={400} lineHeight={24} color="var(--color-text-primary)">Frost, The Bear</CommonTypo>
                                <CommonTypo size={12} fontWeight={400} lineHeight={18} color="var(--color-text-secondary)">Your cutest coach</CommonTypo>
                            </Box>
                        </Box>
                        <Box sx={{
                            cursor: "pointer",
                        }} onClick={handleClose}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.2959 9.79586L12.7959 17.2959C12.6914 17.4007 12.5672 17.484 12.4304 17.5407C12.2937 17.5975 12.1471 17.6267 11.999 17.6267C11.851 17.6267 11.7043 17.5975 11.5676 17.5407C11.4309 17.484 11.3067 17.4007 11.2021 17.2959L3.70215 9.79586C3.4908 9.58451 3.37207 9.29787 3.37207 8.99898C3.37207 8.7001 3.4908 8.41345 3.70215 8.20211C3.91349 7.99076 4.20014 7.87203 4.49902 7.87203C4.79791 7.87203 5.08455 7.99076 5.2959 8.20211L12 14.9062L18.704 8.20117C18.9154 7.98983 19.202 7.87109 19.5009 7.87109C19.7998 7.87109 20.0864 7.98983 20.2978 8.20117C20.5091 8.41252 20.6278 8.69916 20.6278 8.99805C20.6278 9.29693 20.5091 9.58358 20.2978 9.79492L20.2959 9.79586Z" fill={isDarkMode ? "var(--color-text-primary)" :"#656565"} />
                            </svg>
                        </Box>
                    </Box>

                    <Box display={"flex"} flexDirection={"column"} gap={"8px"} mb={"8px"} height={"calc(100vh - 85% - 8px)"} width={"100%"} sx={{
                        overflowY: "auto",
                        position: "relative",
                    }} className="hide-scrollbar" ref={scrollContainerRef} >
                        {!isFromNotification && (
                            <MessageRender
                                text={"Hey, " + (userDetails?.first_name
                                    ? userDetails?.first_name
                                    : "") + "! How can I help you today?"}
                                sendBy={"chat"}
                                loading={false}
                                id={v4()}
                                attachments={null}
                                isDarkMode={isDarkMode}
                            />
                        )}
                        {questionAnswers.map((item, index) => (
                            <MessageRender
                                key={item.id}
                                text={item.text}
                                sendBy={item.sendBy}
                                id={item.id}
                                loading={item.loading}
                                attachments={item.attachments}
                                isDarkMode={isDarkMode}
                            />
                        ))}
                        {followUpQuestions && followUpQuestions.length > 0 && <Box display={"flex"} flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} gap={"8px"}>
                            {followUpQuestions.map(qu => {
                                return <Box sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    minHeight: "36px",
                                    maxWidth: "80%",
                                    padding: "8px",
                                    borderRadius: "12px",
                                    background: isDarkMode ? "var(--dark-background)" : "#fff",
                                    color: "var(--color-text-primary)",
                                    wordWrap: "break-word",
                                    whiteSpace: "pre-wrap",
                                    border: isDarkMode ? "1px solid var(--dark-border)" : "1px solid var(--color-border)",
                                    cursor: "pointer",
                                    "&:hover": {
                                        background: isDarkMode ? "var(--dark-border)" : "var(--color-border)"
                                    }
                                }} onClick={() => {
                                    setfollowUpQuestions([])
                                    askQuesrtion(qu)
                                }}>
                                    <CommonTypo size={12} fontWeight={400} lineHeight={16}>
                                        {qu}
                                    </CommonTypo>
                                </Box>
                            })}
                        </Box>}

                        {/* Quick Replies from Dynamic Flow */}
                        {quickReplies && quickReplies.length > 0 && <Box display={"flex"} flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} gap={"8px"}>
                            {quickReplies.map((reply, index) => {
                                return <Box key={index} sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    minHeight: "36px",
                                    maxWidth: "80%",
                                    padding: "8px",
                                    borderRadius: "12px",
                                    background:isDarkMode ? "var(--dark-background)" : "#fff",
                                    color: isDarkMode ? "var(--color-text-primary)" : "var(--color-text-primary)",
                                    wordWrap: "break-word",
                                    whiteSpace: "pre-wrap",
                                    border: isDarkMode ? "1px solid var(--dark-border)" : "1px solid var(--color-border)",
                                    cursor: "pointer",
                                    "&:hover": {
                                        background: "var(--color-border)"
                                    }
                                }} onClick={() => {
                                    handleQuickReplySelection(reply)
                                }}>
                                    <CommonTypo size={12} fontWeight={400} lineHeight={16}>
                                        {reply.text}
                                    </CommonTypo>
                                </Box>
                            })}
                        </Box>}

                        {/* Holiday Dates Form - Date Picker Interface */}
                        {nextAction === "holiday_dates_form" && (
                            <Box display={"flex"} flexDirection={"column"} gap={"16px"} sx={{ padding: "16px", backgroundColor: "#f8f9fa", borderRadius: "12px", border: "1px solid var(--color-border)" }}>
                                <CommonTypo size={14} fontWeight={600} color="var(--color-text-primary)">
                                    Select Vacation Dates
                                </CommonTypo>

                                <Box display={"flex"} flexDirection={"column"} gap={"12px"}>
                                    {/* Start Date Picker */}
                                    <Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                                        <CommonTypo size={12} fontWeight={500} color="var(--color-text-secondary)">
                                            Start Date
                                        </CommonTypo>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TextField
                                                value={holidayStartDate ? holidayStartDate.format("DD MMM YYYY") : ""}
                                                onClick={(event) => {
                                                    event.currentTarget.blur();
                                                    setStartDatePickerOpen(true);
                                                    setStartDateAnchorEl(event.currentTarget);
                                                }}
                                                placeholder="Select start date"
                                                onFocus={(event) => event.currentTarget.blur()}
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                        border: "1px solid var(--color-border)",
                                                        backgroundColor: "white",
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "12px",
                                                            fontSize: "14px",
                                                            fontWeight: "500"
                                                        }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>

                                    {/* End Date Picker */}
                                    <Box display={"flex"} flexDirection={"column"} gap={"4px"}>
                                        <CommonTypo size={12} fontWeight={500} color="var(--color-text-secondary)">
                                            End Date
                                        </CommonTypo>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <TextField
                                                value={holidayEndDate ? holidayEndDate.format("DD MMM YYYY") : ""}
                                                onClick={(event) => {
                                                    event.currentTarget.blur();
                                                    setEndDatePickerOpen(true);
                                                    setEndDateAnchorEl(event.currentTarget);
                                                }}
                                                placeholder="Select end date"
                                                disabled={!holidayStartDate}
                                                onFocus={(event) => event.currentTarget.blur()}
                                                sx={{
                                                    width: "100%",
                                                    "& .MuiOutlinedInput-root": {
                                                        borderRadius: "8px",
                                                        border: "1px solid var(--color-border)",
                                                        backgroundColor: "white",
                                                        "& .MuiOutlinedInput-input": {
                                                            padding: "12px",
                                                            fontSize: "14px",
                                                            fontWeight: "500"
                                                        }
                                                    }
                                                }}
                                            />
                                        </LocalizationProvider>
                                    </Box>

                                    {/* Submit Button */}
                                    <NewButton
                                        buttonText="Activate Vacation Mode"
                                        onClick={() => {
                                            if (holidayStartDate && holidayEndDate) {
                                                const dateRange = `${holidayStartDate.format("YYYY-MM-DD")} to ${holidayEndDate.format("YYYY-MM-DD")}`;
                                                askQuesrtion(dateRange);
                                            }
                                        }}
                                        isDisabled={!holidayStartDate || !holidayEndDate}
                                        variant="contained"
                                        extraSx={{
                                            width: "100%",
                                            background: "var(--color-new-main)",
                                            border: "none",
                                            height: "40px",
                                            "&:hover": {
                                                background: "var(--color-new-main)",
                                            }
                                        }}
                                    />
                                </Box>
                            </Box>
                        )}

                        {/* Data Options from Dynamic Flow - Sectioned */}
                        {dataOptions && Object.keys(dataOptions).length > 0 && (
                            <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
                                {Object.keys(dataOptions).map((sectionKey, sectionIndex) => (
                                    <Box key={sectionKey} display={"flex"} flexDirection={"column"} gap={"8px"}>
                                        {/* Section Title */}
                                        <CommonTypo
                                            size={14}
                                            fontWeight={600}
                                            color="var(--color-text-primary)"
                                            extraSx={{ textTransform: 'capitalize', marginBottom: '4px' }}
                                        >
                                            {sectionKey}
                                        </CommonTypo>
                                        {/* Section Options */}
                                        <Box display={"flex"} flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} gap={"8px"}>
                                            {dataOptions[sectionKey].map((option, optionIndex) => (
                                                <Box
                                                    key={option.id}
                                                    sx={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        textAlign: "center",
                                                        minHeight: "36px",
                                                        maxWidth: "80%",
                                                        padding: "8px",
                                                        borderRadius: "12px",
                                                        background: option.selected ? "var(--color-new-main)" : isDarkMode ? "var(--dark-background)" : "#fff",
                                                        color: option.selected ? isDarkMode ? "var(--white-background)" : "white" : "var(--color-text-primary)",
                                                        wordWrap: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                        border: `1px solid ${option.selected ? "var(--color-new-main)" : isDarkMode ? "var(--dark-border)" : "var(--color-border)"}`,
                                                        cursor: "pointer",
                                                        "&:hover": {
                                                            background: option.selected ? "var(--color-new-main)" : isDarkMode ? "var(--dark-border)" : "var(--color-border)"
                                                        }
                                                    }}
                                                    onClick={() => {
                                                        handleDataOptionToggle(sectionKey, option.id)
                                                    }}
                                                >
                                                    <CommonTypo size={12} fontWeight={400} lineHeight={16} {...(isDarkMode && option.selected ? { color: "var(--white-background)" } : {})}>
                                                        {option.text}
                                                    </CommonTypo>
                                                </Box>
                                            ))}
                                        </Box>

                                        {/* Horizontal Line (except for last section) */}
                                        {sectionIndex < Object.keys(dataOptions).length - 1 && (
                                            <Box
                                                sx={{
                                                    width: "100%",
                                                    height: "1px",
                                                    background: "var(--color-border)",
                                                    margin: "8px 0"
                                                }}
                                            />
                                        )}
                                    </Box>
                                ))}

                                {/* Submit Button for Data Options */}
                                {selectedDataOptions.length > 0 && (
                                    <Box display={"flex"} justifyContent={"center"} marginTop={"8px"}>
                                        <Box
                                            sx={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                minHeight: "40px",
                                                padding: "8px 16px",
                                                borderRadius: "12px",
                                                background: "var(--color-new-main)",
                                                color: "white",
                                                cursor: "pointer",
                                                "&:hover": {
                                                    background: "var(--color-new-main)",
                                                    opacity: 0.9
                                                }
                                            }}
                                            onClick={handleDataOptionsSubmit}
                                        >
                                            <CommonTypo size={14} fontWeight={500} {...(isDarkMode ? { color: "var(--white-background)" } : {})}>
                                                Submit Selection ({selectedDataOptions.length})
                                            </CommonTypo>
                                        </Box>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {suggestionList && suggestionList.length > 0 && <Box display={"flex"} flexWrap={"wrap"} justifyContent={"center"} alignItems={"center"} gap={"8px"}>
                            {suggestionList.map(qu => {
                                return <Box sx={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    minHeight: "36px",
                                    maxWidth: "80%",
                                    padding: "8px",
                                    borderRadius: "12px",
                                    background: isDarkMode ? "var(--dark-background)" : "#fff",
                                    color: "var(--color-text-primary)",
                                    wordWrap: "break-word",
                                    whiteSpace: "pre-wrap",
                                    border: isDarkMode ? "1px solid var(--dark-border)" : "1px solid var(--color-border)",
                                    cursor: "pointer",
                                    "&:hover": {
                                        background: isDarkMode ? "var(--dark-border)" : "var(--color-border)"
                                    }
                                }} onClick={() => {
                                    setSuggestionList([])
                                    setSelectedSuggestion(qu)
                                    setIsTextInputEnabled(false) // Disable input when starting suggestion flow

                                    // Add user selection and loading with the suggestion question
                                    const chatId = v4()
                                    setQuestionAnswers(prevAnswers => {
                                        const currentAnswers = [...prevAnswers]
                                        // Add user selection
                                        currentAnswers.push({
                                            text: qu.question,
                                            sendBy: "self",
                                            id: chatId
                                        })
                                        // Add loading bot response with the suggestion question
                                        currentAnswers.push({
                                            sendBy: "chat",
                                            loading: true,
                                            id: chatId + "_loading",
                                            text: qu.question
                                        })
                                        return currentAnswers
                                    })

                                    handleDynamicFlow(qu.question_type, null, true, chatId)
                                }}>
                                    <CommonTypo size={12} fontWeight={400} lineHeight={16}>
                                        {qu.question}
                                    </CommonTypo>
                                </Box>
                            })}
                        </Box>}
                    </Box>
                    <Box width={"100%"} position={"absolute"} bottom={"0"} display={"flex"} flexDirection={"column"} gap={"16px"}>
                        {/* Selected Files Thumbnails - Only visible in description mode */}
                        {inputEnabledActions.includes(nextAction) && selectedFiles.length > 0 && (
                            <Box display={"flex"} flexWrap={"wrap"} gap={"4px"} marginBottom={"8px"}>
                                {selectedFiles.map((file, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            position: "relative",
                                            width: "60px",
                                            height: "60px",
                                            borderRadius: "8px",
                                            overflow: "hidden",
                                            border: "1px solid var(--color-border)",
                                            background: "#f5f5f5"
                                        }}
                                    >
                                        {file.type.startsWith('image/') ? (
                                            <img
                                                src={URL.createObjectURL(file)}
                                                alt={file.name}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover"
                                                }}
                                            />
                                        ) : (
                                            <Box sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "100%",
                                                height: "100%",
                                                background: "#e0e0e0"
                                            }}>
                                                <CommonTypo size={10} fontWeight={400} color="var(--color-text-secondary)">
                                                    📹
                                                </CommonTypo>
                                            </Box>
                                        )}
                                        <Box
                                            sx={{
                                                position: "absolute",
                                                top: "2px",
                                                right: "2px",
                                                width: "16px",
                                                height: "16px",
                                                borderRadius: "50%",
                                                background: "var(--color-new-main)",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                cursor: "pointer",
                                                "&:hover": {
                                                    background: "#ff4444"
                                                }
                                            }}
                                            onClick={() => removeFile(index)}
                                        >
                                            <CommonTypo size={10} fontWeight={400} color="white">
                                                ✕
                                            </CommonTypo>
                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        )}

                        <TextField
                            placeholder={
                                isTextInputEnabled
                                    ? (nextAction === "holiday_dates_form"
                                        ? "Use date picker above to select dates"
                                        : "Enter your message...")
                                    : "Please select an option above"
                            }
                            variant="outlined"
                            fullWidth
                            type={'text'}
                            multiline
                            name="password"
                            value={inputValue}
                            disabled={!isTextInputEnabled || nextAction === "holiday_dates_form"}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && !e.shiftKey && isTextInputEnabled) {
                                    e.preventDefault();
                                    onHandleInputSubmit();
                                }
                            }}
                            // error={Boolean(formData.errors.password)}
                            // helperText={formData.errors.password}
                            className={"chatbotInput"}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            {/* Attachment Button - Only visible in description mode */}
                                            {inputEnabledActions.includes(nextAction) && (
                                                <>
                                                    <input
                                                        type="file"
                                                        multiple
                                                        accept="image/*,video/*"
                                                        onChange={handleFileSelection}
                                                        style={{ display: 'none' }}
                                                        id="attachment-input"
                                                    />
                                                    <IconButton
                                                        component="label"
                                                        htmlFor="attachment-input"
                                                        disabled={!isTextInputEnabled}
                                                        sx={{
                                                            background: isTextInputEnabled ? "transparent" : "#ccc",
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            height: "32px",
                                                            width: "32px",
                                                            position: "relative",
                                                            "&:hover": {
                                                                background: isTextInputEnabled ? "transparent" : "#ccc",
                                                            }
                                                        }}
                                                    >
                                                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M13.2799 9.03071L8.15112 14.1557C7.44764 14.8589 6.4936 15.2539 5.4989 15.2537C4.50419 15.2536 3.5503 14.8583 2.84706 14.1548C2.14382 13.4513 1.74885 12.4972 1.74902 11.5025C1.7492 10.5078 2.14451 9.55394 2.848 8.85071L8.983 2.73258C9.45202 2.26381 10.088 2.00056 10.7512 2.00073C11.0795 2.00082 11.4046 2.06558 11.7079 2.19131C12.0112 2.31704 12.2868 2.50128 12.5189 2.73352C12.751 2.96575 12.9351 3.24143 13.0607 3.54481C13.1863 3.84819 13.2509 4.17334 13.2508 4.50168C13.2507 4.83002 13.1859 5.15513 13.0602 5.45845C12.9345 5.76176 12.7502 6.03734 12.518 6.26945L12.5074 6.27946L6.51987 12.0432C6.44888 12.1115 6.36513 12.1651 6.2734 12.201C6.18168 12.237 6.08378 12.2545 5.98529 12.2526C5.8868 12.2506 5.78966 12.2293 5.6994 12.1899C5.60914 12.1504 5.52754 12.0936 5.45925 12.0226C5.39096 11.9516 5.33733 11.8678 5.30141 11.7761C5.26549 11.6844 5.24798 11.5865 5.2499 11.488C5.25181 11.3895 5.27311 11.2924 5.31257 11.2021C5.35203 11.1118 5.40888 11.0302 5.47987 10.962L11.4617 5.20445C11.6487 5.01632 11.7533 4.76161 11.7525 4.49636C11.7517 4.23111 11.6455 3.97706 11.4574 3.79008C11.3642 3.6975 11.2537 3.62417 11.1322 3.57429C11.0107 3.5244 10.8806 3.49893 10.7493 3.49934C10.484 3.50016 10.23 3.60632 10.043 3.79446L3.908 9.91071C3.48606 10.3328 3.24908 10.9052 3.24919 11.5021C3.24925 11.7976 3.30752 12.0902 3.42066 12.3632C3.53381 12.6362 3.69962 12.8843 3.90862 13.0932C4.11763 13.3021 4.36574 13.4678 4.63879 13.5809C4.91184 13.6939 5.20448 13.7521 5.5 13.752C6.09684 13.7519 6.66918 13.5147 7.09112 13.0926L12.2199 7.96758C12.2896 7.89782 12.3725 7.84247 12.4636 7.80472C12.5548 7.76696 12.6525 7.74753 12.7511 7.74753C12.8498 7.74753 12.9475 7.76696 13.0386 7.80472C13.1298 7.84247 13.2126 7.89782 13.2824 7.96758C13.3521 8.03735 13.4075 8.12017 13.4452 8.21132C13.483 8.30247 13.5024 8.40017 13.5024 8.49883C13.5024 8.59749 13.483 8.69519 13.4452 8.78634C13.4075 8.87749 13.3521 8.96032 13.2824 9.03008L13.2799 9.03071Z" fill="#292B2A" />
                                                        </svg>
                                                    </IconButton>
                                                </>
                                            )}

                                            {/* Send Button */}
                                            <IconButton
                                                aria-label="send message"
                                                disabled={!isTextInputEnabled}
                                                sx={{
                                                    background: isTextInputEnabled ? "var(--color-new-main)" : "#ccc",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    height: "32px",
                                                    width: "32px",
                                                    position: "relative",
                                                    "&:hover": {
                                                        background: isTextInputEnabled ? "var(--color-new-main)" : "#ccc",
                                                    }
                                                }}
                                                onClick={onHandleInputSubmit}
                                                edge="end"
                                            >
                                                <SendIcon sx={{
                                                    color: isTextInputEnabled ? "black" : "#666",
                                                    transform: "rotate(-45deg)",
                                                    position: "absolute",
                                                    height: "16px",
                                                    width: "16px",
                                                    top: 6,
                                                    right: 6
                                                }} />
                                            </IconButton>
                                        </Box>
                                    </InputAdornment>
                                )
                            }}
                        />
                    </Box>
                </Box>
            </Popover>}

            {/* Notification Popover */}
            {notificationData && (
                <Popover
                    open={isNotificationOpen}
                    anchorEl={notificationAnchorEl}
                    onClose={handleNotificationClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    sx={{
                        '& .MuiPopover-paper': {
                            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                            maxWidth: '350px',
                            minWidth: '350px',
                            overflow: 'visible',
                            position: 'relative',
                            marginRight: '18px', // 10px gap + 8px arrow extension = 18px
                            left: 'calc(100% - 450px) !important', // Reduce 20px from MUI's dynamic left positioning
                            borderRadius: "12px",
                            padding: "24px",
                            gap: "16px",
                            backgroundColor: "white",
                            '&::after': {
                                content: '""',
                                position: 'absolute',
                                bottom: '20px',
                                right: '-8px',
                                width: '0',
                                height: '0',
                                borderTop: '8px solid transparent',
                                borderBottom: '8px solid transparent',
                                borderLeft: '8px solid white',
                                filter: 'drop-shadow(2px 0 4px rgba(0, 0, 0, 0.1))'
                            }
                        }
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px'
                    }}>
                        <Box display={"flex"} width={"100%"} alignItems={"center"} gap={"16px"}>
                            <Box height={"48px"} width={"48px"} sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer"
                            }} onClick={handleClick}>
                                <img src={"/chatbotinner.svg"} style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    borderRadius: "12px 12px 0px 0px",
                                    objectPosition: "center 75%"
                                }} alt="login"></img>
                            </Box>
                            <Box display={"flex"} alignContent={"flex-start"} flexDirection={"column"}>
                                <CommonTypo size={16} fontWeight={400} lineHeight={24} color="var(--color-text-primary)">Frost, The Bear</CommonTypo>
                                <CommonTypo size={12} fontWeight={400} lineHeight={18} color="var(--color-text-secondary)">Your cutest coach</CommonTypo>
                            </Box>
                        </Box>
                        <Box sx={{
                            width: "302px",
                            borderRadius: "12px",
                            padding: "16px",
                            border: "1px solid var(--color-border)",
                        }}>
                            <CommonTypo size={16} fontWeight={400} lineHeight={24} color="var(--color-text-primary)">{notificationData.notification?.message}</CommonTypo>
                        </Box>
                        <Box sx={{
                            width: "302px",
                            display: "flex",
                            gap: "8px",
                            alignItems: "center",
                        }}>
                            <NewButton
                                buttonText={
                                    getNotificationPopoverCancelButtonText()
                                }
                                onClick={() => {
                                    // Close notification popover
                                    handleNotificationClose();
                                }}
                                typographySx={{
                                    whiteSpace: "nowrap",
                                }}
                                variant="contained"
                                extraSx={{
                                    // width: "120px",
                                    flex: 1,
                                    whiteSpace: "nowrap",
                                    background: "var(--color-border)",
                                    border: "none",
                                    height: "40px",
                                    "&:hover": {
                                        background: "var(--color-border)",
                                    }
                                }}
                            />
                            <NewButton
                                buttonText={getNotificationPopoverButtonText()}
                                onClick={() => {
                                    // Close notification popover
                                    handleNotificationClose();

                                    // Set flag to indicate user came from notification
                                    setIsFromNotification(true);

                                    // Open main chatbot popover
                                    setIsPopupOpen(true);
                                    setAnchorEl(document.querySelector('[data-chatbot-trigger]'));
                                    // Call handleDynamicFlow with notification type (initial request, no user_answer)
                                    const questionType = notificationData.type; // e.g., "RATING"
                                    handleDynamicFlow(questionType);
                                }}
                                variant="contained"
                                extraSx={{
                                    // width: "120px",
                                    flex: 1,
                                    whiteSpace: "nowrap",
                                    background: "var(--color-new-main)",
                                    border: "none",
                                    height: "40px",
                                    "&:hover": {
                                        background: "var(--color-new-main)",
                                    }
                                }}
                            />
                        </Box>
                    </Box>
                </Popover>
            )}

            {/* Date Picker Popovers for Holiday Mode */}
            {startDatePickerOpen && (
                <Popover
                    open={Boolean(startDateAnchorEl)}
                    anchorEl={startDateAnchorEl}
                    onClose={() => {
                        setStartDatePickerOpen(false);
                        setStartDateAnchorEl(null);
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    sx={{
                        '& .MuiPaper-root': {
                            background: "#FFFFFF",
                            boxShadow: "0px 0px 64px 0px #190D1A1A",
                            borderRadius: "12px",
                            width: "312px"
                        }
                    }}
                >
                    <StaticDatePicker
                        value={holidayStartDate}
                        onChange={(newValue) => {
                            setHolidayStartDate(newValue);
                            setStartDatePickerOpen(false);
                            setStartDateAnchorEl(null);
                            // Clear end date if it's before the new start date
                            if (holidayEndDate && newValue && holidayEndDate.isBefore(newValue)) {
                                setHolidayEndDate(null);
                            }
                        }}
                        displayStaticWrapperAs="desktop"
                        disablePast
                        componentsProps={{
                            actionBar: { sx: { display: "none" } },
                        }}
                        className={classes.calendarClassSetting}
                        inputFormat="DD MMM YYYY"
                        renderInput={(params) => <TextField
                            {...params}
                            sx={{
                                width: "200px", // Set width to 200px
                                "&.MuiTextField-root": {
                                    marginBottom: "0px !important",
                                },

                                "& .MuiOutlinedInput-root": {
                                    alignItems: "center",
                                    color: "#19442E",
                                    gap: "8px",
                                    borderRadius: "16px !important",
                                    border: "1px solid #F3F3F3",
                                    background: "#FFF",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "16px 12px !important",
                                        color: "#19442E!important",
                                        '&::placeholder': {
                                            textTransform: "uppercase"
                                        },
                                    },
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {null}
                                    </InputAdornment>
                                ),
                            }}
                        />}
                    />
                </Popover>
            )}

            {endDatePickerOpen && (
                <Popover
                    open={Boolean(endDateAnchorEl)}
                    anchorEl={endDateAnchorEl}
                    onClose={() => {
                        setEndDatePickerOpen(false);
                        setEndDateAnchorEl(null);
                    }}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    sx={{
                        '& .MuiPaper-root': {
                            background: "#FFFFFF",
                            boxShadow: "0px 0px 64px 0px #190D1A1A",
                            borderRadius: "12px",
                            width: "312px"
                        }
                    }}
                >
                    <StaticDatePicker
                        value={holidayEndDate}
                        onChange={(newValue) => {
                            setHolidayEndDate(newValue);
                            setEndDatePickerOpen(false);
                            setEndDateAnchorEl(null);
                        }}
                        displayStaticWrapperAs="desktop"
                        disablePast
                        shouldDisableDate={(date) => {
                            if (holidayStartDate) {
                                return date.isSame(holidayStartDate, 'day') || date.isBefore(holidayStartDate, 'day');
                            }
                            return false;
                        }}
                        componentsProps={{
                            actionBar: { sx: { display: "none" } },
                        }}
                        className={classes.calendarClassSetting}
                        inputFormat="DD MMM YYYY"
                        renderInput={(params) => <TextField
                            {...params}
                            sx={{
                                width: "200px", // Set width to 200px
                                "&.MuiTextField-root": {
                                    marginBottom: "0px !important",
                                },

                                "& .MuiOutlinedInput-root": {
                                    alignItems: "center",
                                    color: "#19442E",
                                    gap: "8px",
                                    borderRadius: "16px !important",
                                    border: "1px solid #F3F3F3",
                                    background: "#FFF",
                                    "& .MuiOutlinedInput-input": {
                                        padding: "16px 12px !important",
                                        color: "#19442E!important",
                                        '&::placeholder': {
                                            textTransform: "uppercase"
                                        },
                                    },
                                },
                            }}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        {null}
                                    </InputAdornment>
                                ),
                            }}
                        />}
                    />
                </Popover>
            )}
        </LocalizationProvider>
    </Box>

}

export default Chatbot

const MessageRender = ({
    text,
    sendBy,
    id,
    loading,
    attachments,
    isDarkMode
}) => {
    return <Box maxWidth={"100%"} key={id} sx={{
        display: "flex",
        justifyContent: sendBy === "self" ? "flex-end" : "flex-start",
    }}>
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: sendBy === "self" ? "flex-end" : "flex-start",
            maxWidth: "100%",
        }}>
            <Box sx={{
                display: "inline-flex",
                alignItems: "center",
                minHeight: "36px",
                maxWidth: "100%",
                padding: "8px",
                borderRadius: "12px",
                background: sendBy === "self" ? "var(--color-new-main)" : isDarkMode ? "var(--dark-background)" : "#fff",
                color: sendBy === "self" ? isDarkMode ? "var(--white-background)" : "white" : "var(--color-text-primary)",
                wordWrap: "break-word",
                whiteSpace: "pre-wrap",
                border: sendBy === "self" ? "none" : isDarkMode ? "1px solid var(--dark-border)" : "1px solid var(--color-border)",
            }}>
                {loading ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <CircularProgress size={12} thickness={4} />
                        <CommonTypo size={12} fontWeight={400} lineHeight={16}>
                            Typing...
                        </CommonTypo>
                    </Box>
                ) : (
                    <CommonTypo size={12} fontWeight={400} lineHeight={16} {...(isDarkMode && sendBy === "self" ? { color: "var(--white-background)" } : {})}>
                        {text}
                    </CommonTypo>
                )}
            </Box>

            {/* Attachments Display */}
            {attachments && attachments.length > 0 && (
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    marginTop: "4px",
                    maxWidth: "200px"
                }}>
                    <CommonTypo size={14}
                        fontWeight={600}
                        color="var(--color-text-primary)"
                        extraSx={{ textTransform: 'capitalize', marginBottom: '4px' }}>
                        Attachments
                    </CommonTypo>
                    <Box sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "4px"
                    }}>
                        {attachments.map((attachment, index) => (
                            <Box
                                key={index}
                                sx={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "6px",
                                    overflow: "hidden",
                                    border: "1px solid var(--color-border)"
                                }}
                            >
                                <img
                                    src={`${baseEndpoints.getImage}${attachment}`}
                                    alt={`Attachment ${index + 1}`}
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover"
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Box>
            )}
        </Box>
    </Box>
}